export default __webpack_public_path__ + "static/media/Snd_C0.cc7a5f24.mp3";